import Stack from "@mui/material/Stack";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";

import MKButton from "components/MKButton";

const APP_STORE_URL = "https://apps.apple.com/us/app/spechs/id6751472895";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.spechs.mobileapp";

function AppStoreButtons({ variant, justify }) {
  const isDark = variant === "dark";

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      justifyContent={justify}
      sx={{ "& > *": { width: { xs: "100%", sm: 180 } } }}
    >
      <MKButton
        variant="contained"
        size="large"
        startIcon={<Icon>apple</Icon>}
        href={APP_STORE_URL}
        target="_blank"
        rel="noreferrer"
        sx={{
          px: 1,
          background: isDark ? "#32373c" : "white",
          color: isDark ? "white" : "#32373c",
          boxShadow: "none",
          "&:hover": {
            background: isDark ? "#1a1a1a" : "#f0f2f5",
            boxShadow: "none",
          },
        }}
      >
        App Store
      </MKButton>
      <MKButton
        variant="outlined"
        size="large"
        startIcon={<Icon>android</Icon>}
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noreferrer"
        sx={{
          px: 1,
          color: isDark ? "white" : "white",
          borderColor: isDark ? "rgba(255,255,255,0.5)" : "rgba(255,255,255,0.4)",
          "&:hover": {
            borderColor: "white",
            background: "rgba(255,255,255,0.08)",
          },
        }}
      >
        Google Play
      </MKButton>
    </Stack>
  );
}

AppStoreButtons.defaultProps = {
  variant: "dark",
  justify: "flex-start",
};

AppStoreButtons.propTypes = {
  variant: PropTypes.oneOf(["dark", "light"]),
  justify: PropTypes.string,
};

export default AppStoreButtons;
